export default "__VITE_ASSET__Bcrlxxmg__"